/* ==================================================
  preorder-button
  発売日時（custom.release_date）に達した瞬間、リロード無しで
  「Coming soon」ボタンを購入可能なカートボタンへ切り替える。

  土台はサーバー側 Liquid（発売前後の判定）。本スクリプトは
  ページを開いたままのユーザー向けに切替を上乗せするのみで、
  JS が無効でも初期表示は常に正しい。
===================================================*/

if (!customElements.get('preorder-button')) {
  customElements.define(
    'preorder-button',
    class PreorderButton extends HTMLElement {
      connectedCallback() {
        /* 発売日時（Unix エポック秒）→ ミリ秒 */
        const releaseAt = parseInt(this.dataset.releaseAt, 10) * 1000;
        if (!releaseAt) return;

        const diff = releaseAt - Date.now();

        /* 既に発売時刻を過ぎていれば即解放 */
        if (diff <= 0) {
          this.release();
          return;
        }

        /*  setTimeout の上限(約24.8日)未満のときのみ予約。
            それ以遠はページを開きっぱなしにする想定が薄いため、
            次回読込時に Liquid 側で正しく描画される  */
        if (diff < 2147483647) {
          this.timer = setTimeout(() => this.release(), diff);
        }
      }

      disconnectedCallback() {
        if (this.timer) clearTimeout(this.timer);
      }

      /* ------------------------------
        ボタンを購入可能状態へ切り替え
      ------------------------------*/

      release() {
        const button = this.querySelector('[type="submit"]');
        if (button) {
          button.removeAttribute('disabled');
          button.removeAttribute('aria-disabled');
          const label = button.querySelector('span');
          if (label && this.dataset.availableLabel) {
            label.textContent = this.dataset.availableLabel;
          }
        }

        /*  hidden の variant id を有効化して購入を許可  */
        const form = this.closest('product-form');
        const variantInput = form && form.querySelector('.product-variant-id');
        if (variantInput) variantInput.disabled = false;
      }
    }
  );
}
